import React, { useState, useEffect } from "react";
import { FiExternalLink, FiClock } from "react-icons/fi";
import "../styles/Registration.css";

const Registration = () => {
  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRegistrationStatus();
  }, []);

  const fetchRegistrationStatus = async () => {
    try {
      const response = await fetch('http://localhost:8000/api/registration-status/');
      if (response.ok) {
        const data = await response.json();
        setRegistrationData(data);
      } else {
        // Fallback data if API fails
        setRegistrationData({
          is_open: true,
          cohort_number: 4,
          beginners_form_url: "https://forms.gle/ujCb9YopPVzffiNR7",
          beginners_exp_form_url: "https://forms.gle/CfF4E5XbLXtea6ZB6",
          intermediates_form_url: "https://forms.gle/3ohjbbfEXGGzbv6AA"
        });
      }
    } catch (error) {
      console.error('Failed to fetch registration status:', error);
      // Fallback data
      setRegistrationData({
        is_open: true,
        cohort_number: 4,
        beginners_form_url: "https://forms.gle/ujCb9YopPVzffiNR7",
        beginners_exp_form_url: "https://forms.gle/CfF4E5XbLXtea6ZB6",
        intermediates_form_url: "https://forms.gle/3ohjbbfEXGGzbv6AA"
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <main className="registration-page section">
        <div className="section__inner">
          <div className="loading-state">
            <p>Loading registration information...</p>
          </div>
        </div>
      </main>
    );
  }

  if (!registrationData?.is_open) {
    return (
      <main className="registration-page section">
        <div className="section__inner">
          <header className="registration-hero">
            <div className="closed-icon">
              <FiClock size={48} />
            </div>
            <h1>
              <span className="accent">Data Epic</span> Registration Closed
            </h1>
            <p>
              Registration for Cohort {registrationData?.cohort_number || 'current'} is currently closed. 
              Follow us on social media or check back later for updates on the next cohort.
            </p>
          </header>
        </div>
      </main>
    );
  }

  return (
    <main className="registration-page section">
      <div className="section__inner">
        <header className="registration-hero">
          <h1>
            Join <span className="accent">Data Epic</span> Cohort {registrationData?.cohort_number || 4}
          </h1>
          <p>
            Choose your learning path and register via the official Google
            Forms. All sessions are structured, practical and guided by
            experienced mentors.
          </p>
        </header>

        <section className="registration-grid">
          <article className="reg-card">
            <div className="reg-card__head">
              <h2>Beginners</h2>
              <p>Start from fundamentals. No prior experience required.</p>
            </div>
            <ul className="reg-card__list">
              <li>Hands-on intro to data & Python</li>
              <li>Live mentorship and community support</li>
              <li>Beginner-friendly projects</li>
            </ul>
            <div className="reg-card__cta">
              <a
                className="btn btn--primary"
                href={registrationData?.beginners_form_url || "https://forms.gle/ujCb9YopPVzffiNR7"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Register for Beginners (opens Google Form)"
              >
                Register
                <FiExternalLink className="btn__icon" />
              </a>
            </div>
          </article>

          <article className="reg-card">
            <div className="reg-card__head">
              <h2>Beginners with Experience</h2>
              <p>For self-starters who have basic familiarity.</p>
            </div>
            <ul className="reg-card__list">
              <li>Faster pace with focused refreshers</li>
              <li>More challenging exercises</li>
              <li>Portfolio-ready mini-projects</li>
            </ul>
            <div className="reg-card__cta">
              <a
                className="btn btn--primary"
                href={registrationData?.beginners_exp_form_url || "https://forms.gle/CfF4E5XbLXtea6ZB6"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Register for Beginners with Experience (opens Google Form)"
              >
                Register
                <FiExternalLink className="btn__icon" />
              </a>
            </div>
          </article>

          <article className="reg-card">
            <div className="reg-card__head">
              <h2>Intermediates</h2>
              <p>Level up with deeper, real-world problem solving.</p>
            </div>
            <ul className="reg-card__list">
              <li>Applied projects and systems thinking</li>
              <li>Team collaboration and code reviews</li>
              <li>Career-focused guidance</li>
            </ul>
            <div className="reg-card__cta">
              <a
                className="btn btn--primary"
                href={registrationData?.intermediates_form_url || "https://forms.gle/3ohjbbfEXGGzbv6AA"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Register for Intermediates (opens Google Form)"
              >
                Register
                <FiExternalLink className="btn__icon" />
              </a>
            </div>
          </article>
        </section>

        <footer className="registration-note">
          <p>
            You will be redirected to a secure Google Form for registration.
            Please ensure you are signed in to Google to complete the process.
          </p>
        </footer>
      </div>
    </main>
  );
};

export default Registration;
